<template>
  <div>
    <div class="top-bar" v-if="!hideAbas">
      <router-link to="/empresas" class="top-mobile text-decoration-none">
        {{ dados.nome_fantasia }} <i class="fa fa-angle-down"></i>
      </router-link>
      <div class="top-contas d-none d-md-flex">
        <a class="top-empresa text-decoration-none pointer" :class="{'active': e.isDefault}"
           v-for="(e, index) in empresas" :aria-disabled="e.pendingRestart ? 'true' : 'false'" @click="changeConta(e, index)">
          <img :src="e.img_empresa || '../../assets/icon.png'" alt="Logo" v-if="e.img_empresa">
          <img src="../../assets/icon.png" alt="Logo" v-else>
          <span class="nome-empresa">{{ e.nome_usuario }} ({{e.nome_fantasia}})<span v-if="getPhone(e)"> - {{ getPhone(e) | phone }}</span></span>
          <span v-if="e.pendingRestart" class="badge badge-warning ml-2">Aguardando</span>
          <span class="badge-notification" v-if="getAtendimentosCount(e)">
            {{ getAtendimentosCount(e) }}
          </span>
        </a>
      </div>
    </div>
    <div class="menu">
      <div class="menu-body">
        <div class="d-none d-md-flex align-items-center justify-content-center mt-1 mb-3">
          <img src="../../assets/icon-white.png" alt="LeCard" style="width: 28px;">
        </div>
        <button title="WhatsApp" aria-label="WhatsApp" @click="toggleBot('/home', true)" class="btn btn-menu" :class="{'btn--active': $route.path.startsWith('/home')}" v-if="isElectron">
          <img src="../../assets/icons/whatsapp.svg">
          <span class="menu-label">WhatsApp</span>
        </button>
        <button title="Chamados" aria-label="Chamados" @click="toggleBot('/chamados', false)" class="btn btn-menu position-relative" :class="{'btn--active': $route.path.startsWith('/chamados')}">
          <img src="../../assets/icons/notification.svg">
          <span class="menu-label">Chamados</span>
          <span class="badge-notification" v-if="atendimentos.status">
            {{ atendimentos.total }}
          </span>
        </button>
        <button v-if="$store.getters['configs/leiaAtiva']" title="Pedidos coletados" aria-label="Pedidos coletados" @click="toggleBot('/pedidos', false)" class="btn btn-menu position-relative" :class="{'btn--active': $route.path.startsWith('/pedidos')}">
          <img src="../../assets/icons/orders.svg" alt="">
          <span class="menu-label">Pedidos</span>
          <span class="badge-notification" v-if="pedidosPendentes">{{ pedidosPendentes }}</span>
        </button>
        <button title="Contatos" aria-label="Contatos" @click="toggleBot('/contatos', false)" class="btn btn-menu" :class="{'btn--active': $route.path.startsWith('/contatos')}">
          <img src="../../assets/icons/add-user.svg">
          <span class="menu-label">Contatos</span>
        </button>
        <div class="menu-bottom">
          <div class="btn-status" title="Status do Bot" @click="toggleStatus" v-if="pauseWpp !== 2">
            <div><b>Bot</b></div>
            <img src="../../assets/icons/switch-off.svg" v-if="pauseWpp">
            <img src="../../assets/icons/switch-on.svg" v-else>
            <div class="mt-0 font-weight-bold" :class="{'text-primary': !pauseWpp}">{{ pauseWpp ? 'Desativado' : 'Ativado' }}</div>
          </div>
          <button title="Configurações" aria-label="Configurações" @click="toggleBot('/configs', false)" class="btn btn-menu btn-block" :class="{'btn--active': $route.path.startsWith('/configs')}">
            <img src="../../assets/icons/settings.svg">
            <span class="menu-label">Configs</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Modal from '../commons/Modal'

  export default {
    name: 'TopBar',
    components: {Modal},
    props: ['home', 'hideAbas'],

    data() {
      return {
        page: '/home',
        bot: true,
        active: 1
      }
    },

    methods: {
      getPhone(empresa) {
        return (this.$store.state.wpp_session.find(session => (session.connectionId || session.key) === empresa.connectionId) || {}).phone;
      },

      getAtendimentosCount(empresa) {
        const total = empresa && empresa.atendimentos
          ? empresa.atendimentos.length
          : 0;

        return total > 9 ? 9 : total;
      },

      toggleBot(url, bot) {
        if (url !== this.$route.path) {
          if (this.isElectron) {
            window.control.toggleBot({ bot, wpp: (this.empresas.find(e => e.isDefault) || {}).wpp || 1 });
          }

          this.page = url;
          this.$router.push(url);
        }
      },

      toggleStatus() {
        window.control.toggleStatus(!this.pauseWpp);
      },

      changeConta(conta) {
        if (conta.pendingRestart) return;
        this.$store.dispatch('selectEmpresa', conta);
        this.$emit('changeEmpresa', conta.wpp);

        if (this.$route.name === 'Empresas') {
          this.$router.push(this.session ? '/home' : '/chamados');
        }
      }
    },

    computed: {
      empresas() {
        return this.$store.state.empresas
      },

      dados() {
        return this.$store.state.dataUser
      },

      pedidosPendentes() {
        return this.$store.state.pedidosColetados.contador.pendentes;
      },

      atendimentos() {
        return this.$store.state.atendimentos
      },

      pauseWpp() {
        return this.$store.state.config.pauseWpp
      },

      session() {
        return this.$store.state.session
      }
    },

    sockets: {
      connect() {
        setTimeout(() => {
          this.connected = true;
          this.$store.commit('SET_MODAL_OFFLINE', false);
        }, 5000);
      },

      disconnect() {
        this.$store.commit('SET_MODAL_OFFLINE', true);
        this.connected = false;
      }
    },

    mounted() {
      setTimeout(() => {
        this.connected = this.$socket ? this.$socket.connected : false;
      }, 10000);
    },

    created() {
      this.$parent.$on('goHome', () => {
        this.toggleBot('/home', true);
      })
    }
  }
</script>
<style scoped>
 .badge-notification {
   background-color: var(--danger);
   position: absolute;
   top: 3px;
   right: 31px;
   color: #fff;
   font-weight: bold;
   width: 14px;
   height: 14px;
   border-radius: 50%;
   font-size: 10px;
   display: flex;
   align-items: center;
   justify-content: center;
 }

 .menu .badge-notification {
   top: -4px;
   right: -4px;
   min-width: 20px;
   width: auto;
   height: 20px;
   padding: 0 4px;
   margin-top: 0;
   border: 2px solid #f7f5f3;
   border-radius: 999px;
   background-color: var(--danger);
   font-size: 11px;
   line-height: 1;
 }

 .btn-status {
   cursor: pointer;
   background-color: #FFFFFF;
   display: block;
   border-radius: 4px;
   padding: 8px 3px;
   text-align: center;
   font-size: 9px;
   text-decoration: none;
   margin-bottom: 10px;
 }

 .btn-status img {
   width: 28px;
 }

 .btn-status .font-weight-bold {
   font-size: 8px;
 }

 .top-empresa {
   position: relative;
   display: flex;
   font-weight: 400;
   border-radius: 6px 6px 0 0;
   align-items: center;
   width: 25%;
   padding: 4px 12px;
   background-color: rgba(255,255,255,0.2);
   color: #fff;
   font-size: 0.8rem;
 }

 .top-empresa:hover {
   background-color: rgba(255,255,255,0.45);
 }

 .top-mobile {
   display: block;
   color: #fff;
   padding: 3px 15px;
   border-bottom: 1px solid #e3e6f0;
   background-color: var(--topbar-bg);
   text-align: center;
 }

 .top-empresa.active:hover, .top-empresa.active {
   color: #000000;
   background-color: #ffffff;
 }

 .top-empresa img {
   width: 16px;
   height: 16px;
   border-radius: 50%;
   object-fit: cover;
   margin-right: 6px;
 }

 .nome-empresa {
   max-width: 75%;
   overflow: hidden;
   text-overflow: ellipsis;
   display: -webkit-box;
   -webkit-box-orient: vertical;
   -webkit-line-clamp: 1;
 }

 @media (min-width: 768px) {
   .top-contas {
     height: 100%;
   }

   .top-empresa {
     min-width: 0;
   }

   .badge-notification {
     top: -4px;
     right: 11px;
   }

   .top-empresa .badge-notification {
     top: 5px;
   }

   .top-mobile {
     display: none;
   }
 }
</style>
